export function indexFlatTree(nodes) {
  const nodeByKey = new Map();
  const childrenByParent = new Map();

  nodes.forEach((node) => {
    nodeByKey.set(node.key, node);

    const siblings = childrenByParent.get(node.parentKey) || [];
    siblings.push(node);
    childrenByParent.set(node.parentKey, siblings);
  });

  return {
    nodeByKey,
    childrenByParent,
    roots: childrenByParent.get(null) || [],
  };
}

export function childNodesOf(index, key) {
  return index.childrenByParent.get(key) || [];
}

function bottomUpOrder(index) {
  const order = [];
  const stack = index.roots.slice();

  while (stack.length) {
    const current = stack.pop();
    order.push(current);
    childNodesOf(index, current.key).forEach((child) => stack.push(child));
  }

  return order.reverse();
}

export function buildSelectionState(index, isSelected) {
  const state = new Map();

  bottomUpOrder(index).forEach((node) => {
    const checked = !!isSelected(node);

    const partialChecked = childNodesOf(index, node.key).some((child) => {
      const childState = state.get(child.key);
      return !!childState && (childState.checked || childState.partialChecked);
    });

    state.set(node.key, { checked, partialChecked });
  });

  return state;
}
